import React from 'react';
import PropTypes from 'prop-types';
import { AvForm } from 'availity-reactstrap-validation';

import { Row } from 'reactstrap';

const IForm = ({ selectedRow, onCreate, onUpdate, onDelete }: any) => {
  const columsPop = 3;
  const columsPop1 = 1;
  const columsPop2 = 3;

  return (
    <>
      <div className="formContainerIFormSummaryImport d-flex flex-column mt-2">
        <Row className="upRownIFormSummaryImport ps-3 me-1">
          <AvForm
            className="custom-form mt-0"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columsPop}, 1fr)`,
              gridAutoRows: 'minmax(10%, 50px)',
              gridGap: '2%',
              padding: '0',
              textAlign: 'center',
            }}
          >
            {selectedRow.Date && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Date </label>
                <label className="labelInfoModal"> {selectedRow.Date}</label>
              </div>
            )}
            {selectedRow.taskId && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Task Id </label>
                <label className="labelInfoModal"> {selectedRow.taskId}</label>
              </div>
            )}
            {selectedRow.status && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Status </label>
                <label className="labelInfoModal">
                  {' '}
                  {selectedRow.status}
                </label>
              </div>
            )}
            {selectedRow.Number && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Number </label>
                <label className="labelInfoModal"> {selectedRow.Number}</label>
              </div>
            )}
            {selectedRow.clientId && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Client Id </label>
                <label className="labelInfoModal">
                  {' '}
                  {selectedRow.clientId}
                </label>
              </div>
            )}
            {selectedRow.createdAt && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Created At </label>
                <label className="labelInfoModal">
                  {' '}
                  {selectedRow.createdAt}
                </label>
              </div>
            )}
            {selectedRow.identificator && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Identificator </label>
                <label className="labelInfoModal"> {selectedRow.identificator}</label>
              </div>
            )}
            {selectedRow.iTask && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Descripcion </label>
                <label className="labelInfoModal"> {selectedRow.iTask.descripcion}</label>
              </div>
            )}
            {selectedRow.entity && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Entity </label>
                <label className="labelInfoModal"> {selectedRow.entity}</label>
              </div>
            )}
          </AvForm>
        </Row>
        <Row className="centerRownIFormSummaryImport">
          <AvForm
            className="custom-form mt-0"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columsPop1}, 1fr)`,
              gridAutoRows: 'minmax(10%, 80px)',
              gridGap: '2%',
              padding: '0',
              textAlign: 'center',
            }}
          >
            {selectedRow.message && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Message </label>
                <label className="labelInfoModal text-break text-wrap">
                  {' '}
                  {selectedRow.message}
                </label>
              </div>
            )}

          </AvForm>
        </Row>

        <Row className="DownRownIFormSummaryImport ps-3 me-1">
          <AvForm
            className="custom-form mt-0"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${columsPop2}, 1fr)`,
              gridAutoRows: 'minmax(10%, 50px)',
              gridGap: '1%',
              padding: '0',
            }}
          >
            {selectedRow.text && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> JSON </label>
                <label className="labelInfoModal"> {selectedRow.text}</label>
              </div>
            )}
            {selectedRow.resultXML && (
              <div className="d-inline-block text-break text-wrap">
                <label className="labelModal"> Result XML </label>
                <label className="labelInfoModal"> {selectedRow.resultXML}</label>
              </div>
            )}
          </AvForm>
        </Row>
      </div>
    </>
  );
};

IForm.propTypes = {
  selectedRow: PropTypes.shape({
    Number: PropTypes.string,
    Operation: PropTypes.string,
    taskId: PropTypes.string,
    id: PropTypes.number,
    ClientId: PropTypes.string,
    dateOfi: PropTypes.string,
    timeOfi: PropTypes.string,
    user: PropTypes.string,
    text1: PropTypes.string,
    text2: PropTypes.string,
    text3: PropTypes.string,
    text4: PropTypes.string,
    text5: PropTypes.string,
    WRNUMBER: PropTypes.string,
    createdAt: PropTypes.string,
  }),
};

export default IForm;
